export const TOKEN_KEY = 'auth-token';
export const USER_KEY = 'auth-user';
export const ROLE_KEY = 'user-role';